<template>
  <div class="zujian">
   <el-dialog title="导入" center :visible.sync="importDialog" @close="closeDialogFile" width="300px" top="20px" :append-to-body="true">
     <input type="file" ref="file"   accept=".xls,.csv,.xlsx"   @change="getFile($event)">
     <div slot="footer" class="dialog-footer">
       <el-button @click="importDialog = false" size="mini">取 消</el-button>
       <el-button type="primary" @click="DRsave()" size="mini">确 定</el-button>
     </div>
   </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'uploadImg',
  data () {
    return {
      importDialog: false,
      file: null
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.importDialog = true
  },
  methods: {
    getFile: function (event) {
      this.file = event.target.files[0]
    },
    DRsave (event) {
      function extname (filename) {
        if (!filename || typeof filename != 'string') {
          return false
        };
        let a = filename.split('').reverse().join('')
        let b = a.substring(0, a.search(/\./)).split('').reverse().join('')
        return b
      }
      if (this.file == null) {
        this.$alert('文件为空,请选择文件进行导入', '系统提示')
      } else {
        let name = extname(this.file.name)
        if (name != 'xlsx' && name != 'csv' && name != 'xls') { // xls,.csv
          this.$alert('请选择正确的文件格式', '系统提示')
        } else {
          if (this.file.size > 500 * 1024) {
            this.$alert('文件不能大于500KB', '系统提示')
          } else {
            let formData = new FormData()
            formData.append('file', this.file)
            this.$emit('DRsave', formData)
          }
        }
      }
    },
    closeDialogFile () {
      this.$emit('destroy')
      this.$refs.file.value = ''
      this.file = null
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
.hidden /deep/.el-upload--picture-card{
  display: none;
}
</style>
